import BaseAPI from './base'
/**
 * API xử lý comment
 */
class CommentAPI extends BaseAPI {}

export default new CommentAPI('v1/comments', 'Comment')
